var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxt-biz-tag" },
    [
      _c(
        "yxt-form",
        { attrs: { size: _vm.size } },
        [
          _c(
            "yxt-form-item",
            { attrs: { error: _vm.error } },
            [
              !_vm.selectMode
                ? [
                    _c(
                      "yxt-popover",
                      {
                        attrs: { placement: "bottom-start", trigger: "manual" },
                        model: {
                          value: _vm.visibleMore,
                          callback: function ($$v) {
                            _vm.visibleMore = $$v
                          },
                          expression: "visibleMore",
                        },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "reference" }, slot: "reference" },
                          [
                            _c(
                              "yxt-input",
                              {
                                staticClass: "mr12",
                                class: { "is-error": _vm.error },
                                style: { width: _vm.width },
                                attrs: {
                                  size: _vm.size,
                                  readonly: !_vm.canInput,
                                  placeholder: _vm.placeholder,
                                  maxlength: _vm.maxlength,
                                  disabled: !_vm.canInput && !_vm.canSelect,
                                },
                                nativeOn: {
                                  keydown: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.createCurrentTag.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.tagValue,
                                  callback: function ($$v) {
                                    _vm.tagValue = $$v
                                  },
                                  expression: "tagValue",
                                },
                              },
                              [
                                _vm.canSelect
                                  ? _c("i", {
                                      staticClass:
                                        "yxt-input__icon yxt-icon-more hand hover-primary-6",
                                      attrs: { slot: "suffix" },
                                      on: { click: _vm.showSelector },
                                      slot: "suffix",
                                    })
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "yxtbiz-tag__wrap" },
                          [
                            _c("yxt-scrollbar", [
                              _c(
                                "ul",
                                {
                                  directives: [
                                    {
                                      name: "clickoutside",
                                      rawName: "v-clickoutside",
                                      value: _vm.cancelRecommend,
                                      expression: "cancelRecommend",
                                    },
                                  ],
                                  staticClass: "yxtbiz-tag_recommend",
                                },
                                _vm._l(_vm.searchList, function (item, index) {
                                  return _c(
                                    "li",
                                    {
                                      key: index,
                                      staticClass:
                                        "ellipsis nowrap hover-bg-primary-1",
                                      class: _vm.createClass(item),
                                      attrs: { title: _vm.setTitle(item) },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectItem(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(item.tagName),
                                        },
                                      }),
                                      !!item.groupId
                                        ? _c("span", [
                                            _vm._v(
                                              "【" +
                                                _vm._s(item.groupName) +
                                                "】"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "yxt-row",
                      {
                        staticClass: "yxtbiz-tag-selection",
                        attrs: { gutter: 5 },
                      },
                      _vm._l(_vm.selected, function (tag, index) {
                        return _c(
                          "yxt-tag",
                          {
                            key: index,
                            staticClass: "yxtbiz-tag-selected",
                            attrs: { closable: "", type: "info" },
                            on: {
                              close: function ($event) {
                                return _vm.deleteTag(tag)
                              },
                            },
                          },
                          [
                            tag.isNew
                              ? _c("yxt-svg", {
                                  staticClass: "yxtbiz-tag-new",
                                  attrs: {
                                    width: "25px",
                                    height: "21px",
                                    "icon-class": "new",
                                  },
                                })
                              : _vm._e(),
                            _c("span", [
                              _vm._v(_vm._s(_vm._f("format")(tag.tagName))),
                            ]),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ]
                : [
                    _c("yxt-select", {
                      staticClass: "mr12",
                      class: { "is-error": _vm.error },
                      style: { width: _vm.width },
                      attrs: {
                        value: _vm.selected,
                        multiple: "",
                        placeholder: _vm.placeholder,
                        size: _vm.size,
                        disabled: !_vm.canSelect,
                        "icon-name": "more",
                        "hidden-option": "",
                        "collapse-tags": "",
                        "value-key": "id",
                        "prop-label": "tagName",
                        clearable: "",
                      },
                      on: {
                        change: _vm.updateSelectVal,
                        "visible-change": _vm.showSelector,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "tag",
                          fn: function (ref) {
                            var data = ref.data
                            return [
                              _c("span", [_vm._v(_vm._s(data.currentLabel))]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _vm.type === "dialog"
        ? _c(
            "yxtf-dialog",
            {
              attrs: {
                visible: _vm.dialogVisible,
                title: _vm.title,
                width: "640px",
                "append-to-body": "",
                "before-close": _vm.beforeClose,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
                close: _vm.close,
                closed: _vm.closed,
              },
            },
            [
              _vm.dialogContentVisible
                ? _c("tag-selector", {
                    attrs: { module: _vm.module },
                    model: {
                      value: _vm.s_selected,
                      callback: function ($$v) {
                        _vm.s_selected = $$v
                      },
                      expression: "s_selected",
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "yxt-button",
                    { attrs: { plain: "" }, on: { click: _vm.close } },
                    [_vm._v(_vm._s(_vm.$t("pc_biz_utility_btn_cancel")))]
                  ),
                  _c(
                    "yxt-button",
                    { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                    [_vm._v(_vm._s(_vm.$t("pc_biz_utility_btn_confirm")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "yxt-drawer",
            {
              attrs: {
                visible: _vm.drawerVisible,
                title: _vm.title,
                size: "640px",
                "destroy-on-close": "",
                "before-close": _vm.beforeClose,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.drawerVisible = $event
                },
                close: _vm.close,
              },
            },
            [
              _c("tag-selector", {
                attrs: { module: _vm.module },
                model: {
                  value: _vm.s_selected,
                  callback: function ($$v) {
                    _vm.s_selected = $$v
                  },
                  expression: "s_selected",
                },
              }),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "yxt-button",
                    { attrs: { plain: "" }, on: { click: _vm.close } },
                    [_vm._v(_vm._s(_vm.$t("pc_biz_utility_btn_cancel")))]
                  ),
                  _c(
                    "yxt-button",
                    { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                    [_vm._v(_vm._s(_vm.$t("pc_biz_utility_btn_confirm")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }